import React from 'react'
import { TLocaleContext } from './LocaleContext'

type TTag = {
  tag: keyof JSX.IntrinsicElements
  props: Record<string, any>
}

export type TPlaceholder = Record<string, string | number | undefined | TTag>

const createLocale = (content: TLocaleContext) => {
  // 函数重载签名
  function locale(
    k: string,
    placeholder: Record<string, TTag>
  ): React.ComponentElement<any, any> | (string | React.ComponentElement<any, any>)[]
  function locale(k: string, placeholder?: Record<string, string | number | undefined>): string
  function locale(k: string, placeholder: any): any {
    let text = content![k]
    if (!text) {
      if (process?.env?.NODE_ENV !== 'production') {
        return `Locale key "${k}" not found`
      }
      return ''
    }
    if (!placeholder) return text
    const tags: (keyof JSX.IntrinsicElements)[] = []
    const matchedTag: Record<string, boolean> = {}
    const replaceResult = text?.replace(/{{(.*?)}}/g, (match, p1) => {
      const placeholderInfo = placeholder[p1]
      if (typeof placeholderInfo !== 'undefined') {
        if (typeof placeholderInfo === 'object' && placeholderInfo.tag) {
          if (tags[tags.length - 1] === placeholderInfo.tag) {
            tags.pop()
            matchedTag[p1] = true
          } else {
            matchedTag[p1] = false
            tags.push(placeholderInfo.tag)
          }
        } else {
          return String(placeholderInfo)
        }
      }
      return match
    })
    return parse(replaceResult, matchedTag, placeholder)
  }
  return locale
}

const parse = (str: string, matchedTag: Record<string, boolean>, placeholder: any) => {
  const reg = /{{(.*?)}}/
  const results: (string | React.ComponentElement<any, any>)[] = []
  let tempStr = str
  while (tempStr) {
    const match = tempStr.match(reg)
    if (match) {
      const [fullMatch, key] = match
      const { index: matchIndex, input: matchInput } = match
      if (matchIndex === undefined || matchInput === undefined) return
      if (!matchedTag[key]) {
        results.push(tempStr.slice(0, matchIndex + fullMatch.length))
        tempStr = matchInput.slice(matchIndex + fullMatch.length)
      } else {
        if (matchIndex > 0) {
          results.push(tempStr.slice(0, matchIndex))
        }
        tempStr = matchInput.slice(matchIndex + fullMatch.length)
        const nextMatch = tempStr.match(new RegExp(`{{${key}}}`))
        if (!nextMatch) {
          console.error(`no matching tag ${key} found`)
          return
        }
        const { index: nextMatchIndex, input: nextMatchInput } = nextMatch
        if (!nextMatchIndex || !nextMatchInput) return
        const childrenString = tempStr.slice(0, nextMatch.index)
        results.push(
          React.createElement(
            placeholder[key].tag,
            {
              key,
              ...placeholder[key].props,
            },
            parse(childrenString, matchedTag, placeholder)
          )
        )
        tempStr = nextMatchInput.slice(nextMatchIndex + nextMatch[0].length)
      }
    } else {
      results.push(tempStr)
      tempStr = ''
    }
  }
  return results?.length === 1 ? results[0] : results
}

export default createLocale
